import { LDContext } from 'launchdarkly-js-client-sdk';

import { getOrganizationRoleNamesFromToken } from './getOrganizationRoleNamesFromToken';

export const ANONYMOUS_LD_CONTEXT: LDContext = {
  kind: 'anonymous',
  key: 'anonymous-key',
};

export type LaunchDarklyUserInfo = {
  ams_user_id: string;
  email?: string;
  given_name?: string;
  family_name?: string;
  user_role_v4?: string;
  compression?: string;
};

type BuildLaunchDarklyContextParams = {
  userInfo?: LaunchDarklyUserInfo | null;
  organizationId?: string;
};

export const buildLaunchDarklyContext = ({ userInfo, organizationId }: BuildLaunchDarklyContextParams): LDContext => {
  if (!userInfo?.ams_user_id) {
    return ANONYMOUS_LD_CONTEXT;
  }

  const userContext: LDContext = {
    kind: 'user',
    key: userInfo.ams_user_id,
    email: userInfo.email,
  };

  if (userInfo.email) {
    userContext.email = userInfo.email;
  }

  const displayName = [userInfo.given_name, userInfo.family_name].filter(Boolean).join(' ').trim();

  if (displayName) {
    userContext.name = displayName;
  }

  if (organizationId) {
    const roles = getOrganizationRoleNamesFromToken(userInfo, organizationId);

    if (roles.length > 0) {
      userContext.roles = roles;
    }
  }

  if (!organizationId) {
    return userContext;
  }

  return {
    kind: 'multi',
    user: userContext,
    organization: {
      kind: 'organization',
      key: organizationId,
    },
  };
};
